<rt-trip
    [tripId]="ormId"
    [showDeleteTripButton]="fromInterfaceValidation"
    (dirty)="onDirty()"
></rt-trip>
